import dropRight from 'lodash/dropRight';
import isEqual from 'lodash/isEqual';

const sameCurrentBase = (path1 = '', path2 = '') => {
  const splitPath1 = path1.split('/');
  const splitPath2 = path2.split('/');
  const path1WithoutLast = dropRight(splitPath1);
  const path2WithoutLast = dropRight(splitPath2);
  return isEqual(path1WithoutLast, path2WithoutLast);
};

export default sameCurrentBase;
